import React, {useEffect, useState, useRef} from "react";
import { marketingStockAPI } from "../../api/api";
import {MarketingStockCard} from "./MarketingStockCard/MarketingStockCard";
import style from "./MarketingStockWrapper.module.css"
import { SpinnerUA } from "../../common/Spinners/SpinerUA/SpinnerUA";

export const MarketingStockWrapper = () => {

    const [stockList, setStockList] = useState([]);
    const [isLoading, setIsLoading] = useState(true)

    const fetchStockList = async() => {
        const {data} = await marketingStockAPI.getMarketingStocks();
        let resp = JSON.parse(data);

        if(resp.isSucccess){
            setStockList(resp.data)
        }
        setIsLoading(false);
        console.log(resp)
    }

    useEffect(() => {
        fetchStockList().then();
    }, [])

    if(isLoading){
        return (
            <div className={style.spinner}>
                <SpinnerUA />
            </div>
        )
    }

    if(!stockList.length){
        return(
            <div style={{height:'100vh', display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center", padding: '20px'}}>
                <h2 style={{margin:'auto'}}>На жаль, Вам зараз недоступна жодна акція</h2>
            </div>

        )
    }

    return (

        <div className={style.stockWrapper}>
            {stockList.length ?  stockList.map((stock) =>
                <MarketingStockCard
                    key={stock.Id}
                    id={stock.Id}
                    name={stock.Name}
                    start={stock.StartTime}
                    end={stock.EndTime}
                    shortDescription={stock.ShortDescription}
                    imageUrls={stock.SmallImageUrls}
                    />
            ) : null}

        </div>
    )
}